import {AuthStatus, AuthUser, LoginFeedback} from '../types/auth';
import * as actionTypes from '../actions/authActionTypes';

type AuthState = {
    user: AuthUser;
    loginFeedback: LoginFeedback | null;
    isLoggingIn: boolean;
    status: AuthStatus;
    scope: string | null;
    llt: string | null;
};

const initialState: AuthState = {
    isLoggingIn: false,
    status: AuthStatus.LOADING,
    loginFeedback: null,
    user: {
        id: '',
        email: '',
        firstName: '',
        lastName: '',
    },
    scope: null,
    llt: null,
};

const auth = (state: AuthState = initialState, action: Action): AuthState => {
    switch (action.type) {
        case actionTypes.AUTH_SET_USER:
            return {
                ...state,
                user: {
                    id: action.payload.id,
                    email: action.payload.email,
                    firstName: action.payload.firstName,
                    lastName: action.payload.lastName,
                },
            };
        case actionTypes.AUTH_AUTHENTICATE_VIA_LOGINLESS:
        case actionTypes.AUTH_AUTHENTICATE:
            return {
                ...state,
                status: AuthStatus.LOADING,
            };
        case actionTypes.AUTH_AUTHENTICATE_SUCCESS:
            return {
                ...state,
                status: AuthStatus.AUTHENTICATED,
                user: {
                    id: action.payload.id,
                    email: action.payload.email,
                    firstName: action.payload.firstName,
                    lastName: action.payload.lastName,
                },
            };
        case actionTypes.AUTH_AUTHENTICATE_VIA_LOGINLESS_SUCCESS:
            return {
                ...state,
                status: AuthStatus.AUTHENTICATED_LOGINLESS,
                user: {
                    id: action.payload.user.id,
                    email: action.payload.user.email,
                },
                llt: action.payload.llt,
                scope: action.payload.scope,
            };
        case actionTypes.AUTH_AUTHENTICATE_VIA_LOGINLESS_FAILED:
            return {
                ...state,
                status: AuthStatus.UNAUTHENTICATED,
                loginFeedback: {
                    success: false,
                    message: action.payload,
                },
                isLoggingIn: false,
            };
        case actionTypes.AUTH_AUTHENTICATE_FAILED:
            return {
                ...state,
                status: AuthStatus.UNAUTHENTICATED,
            };
        case actionTypes.AUTH_LOGIN:
            return {
                ...state,
                isLoggingIn: true,
                loginFeedback: null,
            };
        case actionTypes.AUTH_LOGIN_SUCCESS:
            return {
                ...state,
                loginFeedback: {
                    success: true,
                    message: action.payload,
                },
                isLoggingIn: false,
            };
        case actionTypes.AUTH_LOGIN_FAILED:
            return {
                ...state,
                loginFeedback: {
                    success: false,
                    message: action.payload,
                },
                isLoggingIn: false,
            };
        case actionTypes.AUTH_LOGOUT_SUCCESS:
            return {
                ...initialState,
                status: AuthStatus.LOGOUT,
            };
        default:
            return state;
    }
};

export default auth;
